import React, { useEffect, useState } from 'react'
import '../css/rates.css';
import { Helmet } from 'react-helmet';
import rates from '../images/Rates.png';
import { fetchPageContent, contentLines, contentText } from '../utils/siteContent';

const DEFAULT_PAYMENT_METHODS = [
    '1. Credit/Debit Cards (preferred method): Your card will be automatically charged the first day of the month. We accept VISA, Discover and MasterCard. (We do not accept American Express)',
    '2. Checks/Cash: September-December tuition is required by September 1st and January-June tuition is required by January 1st. You may pre-pay the whole year with a 10% discount (cannot be combined with family discount).',
    'LATE PAYMENTS – if over 3 weeks late, student may be asked to sit out until payment arrangements are made.',
];

const DEFAULT_REQUIRED_FEES = [
    '1. Non-Refundable Annual Registration Fee:',
    '$45 for individuals – (1 more dancer add $35, 2 or more dancers add $25 each)',
    '2. Monthly Tuition:',
    'Pricing is the same no matter how many weeks of class are held in a month. Most months have 4 weeks, but some have 3-5. You are always welcome to do make-ups for missed classes.',
    '3. Performance fees (recital/costume):',
    'Costume Fee: $60-90 (depends on class) per child, per costume.',
    'Recital Fee: $55 for 1 Student. $85 for 2 Students. $105 for 3 Students. No ticket selling required & no limit on number of guests.',
    '4. Additional monthly fees for Company students:',
    'Emerge – $20',
    'Eclipse – $40',
    'Excel – $65',
    'Note: Competition fees for Emerge, Eclipse & Elite Dance Companies are a separate fee.',
];

const DEFAULT_CANCELLATION = [
    'You MUST notify us in writing (email, phone or text) at least 2 weeks prior to the 1st day of the month for which you are cancelling enrollment.',
    'Notification after that date but before the 1st day of the next month = $20 cancellation fee.',
    'Notification between the 1st and the 7th of the month = half tuition refund.',
    'Notification after the 7th = no tuition refund for the current month.',
    "*Please notify us if you don't receive a cancellation confirmation email or text from us.*",
];

export default function Rates() {
    const [content, setContent] = useState(null);

    useEffect(() => {
        fetchPageContent('Rates').then(setContent);
    }, []);

    return (
        <div className="rates-content">
            <Helmet>
                <title>In Motion Dance | Rates</title>
            </Helmet>
            <h1>Our Rates</h1>

            <div className="rates-paymentMethods">
                <h2>Payment Methods</h2>
                {contentLines(content, 'payment_methods', DEFAULT_PAYMENT_METHODS).map((line, i) => <p key={i}>{line}</p>)}
            </div>

            <div className="rates-requiredFees">
                <h2>Required Fees</h2>
                {contentLines(content, 'required_fees', DEFAULT_REQUIRED_FEES).map((line, i) => <p key={i}>{line}</p>)}
            </div>

            <div className="rates-studentHours">
                <h2>Class Rates</h2>
                <p className="rates-studentHourNote">
                    Updated: {contentText(content, 'rates_updated', 'Sunday, April 19, 2026')}
                </p>
                <img src={rates} alt="Class rate chart" />
                <p>{contentText(content, 'private_lesson_note', 'Private Hourly Room Rental - $45 per hour')}</p>
            </div>

            <div className="rates-adultClasses">
                <h2>Adult Fitness</h2>
                <p>{contentText(content, 'adult_fitness', 'Adult Fitness: 10 class punch pass $30')}</p>
            </div>

            <div className="rates-latefees">
                <h2>Late Fees</h2>
                <p>{contentText(content, 'late_fees', 'If tuition is not paid in full by the 7th day of each month, a $10 per week late fee will begin to be assessed until tuition is paid in full.')}</p>
            </div>

            <div className="rates-cancellation">
                <h2>Cancellation</h2>
                {contentLines(content, 'cancellation', DEFAULT_CANCELLATION).map((line, i) => <p key={i}>{line}</p>)}
            </div>
        </div>
    )
}
